import cn from 'classnames';
import SearchForm from './components/SearchForm/SearchForm.css';
import LocationAutocomplete from './components/LocationAutocomplete/LocationAutocomplete.css';
import SearchFormDatepicker from './components/SearchFormDatepicker/SearchFormDatepicker.css';
import Passengers from './components/Passengers/Passengers.css';
import Results from './components/Results/Results.css';
import Stepbar from './components/Stepbar/Stepbar.css';
import QuickSearchForm from './components/QuickSearchForm/QuickSearchForm.css';
import WeekCalendar from './components/WeekCalendar/WeekCalendar.css';
import DesktopFlightRoute from './components/DesktopFlightRoute/DesktopFlightRoute.css';
import Amenities from './components/Amenities/Amenities.css';
import DesktopFlight from './components/DesktopFlight/DesktopFlight.css';
import FareGroup from './components/FareGroup/FareGroup.css';
import FlightCard from './components/FlightCard/FlightCard.css';
import Toolbar from './components/Toolbar/Toolbar.css';
import Checkout from './components/Checkout/Checkout.css';
import CheckoutConsents from './components/Checkout/Consents/Consents.css';
import MobileFlight from './components/MobileFlight/MobileFlight.css';
import CompareFares from './components/CompareFares/CompareFares.css';
import PriceGraph from './components/PriceGraph/PriceGraph.css';
import * as SeatMap from './components/SeatMap/SeatMap.css';
import * as Airplane from './components/SeatMap/Airplane/Airplane.css';
import * as AirplaneInfo from './components/SeatMap/AirplaneInfo/AirplaneInfo.css';
import * as Passenger from './components/SeatMap/Passenger/Passenger.css';
import * as MobilePassenger from './components/SeatMap/MobilePassenger/MobilePassenger.css';
import * as SeatMapPassengers from './components/SeatMap/Passengers/Passengers.css';
import * as Disclaimer from './components/SeatMap/Disclaimer/Disclaimer.css';
import * as Controls from './components/SeatMap/Controls/Controls.css';
import * as DoubleSeat from './components/SeatMap/DoubleSeat/DoubleSeat.css';
import * as Seat from './components/SeatMap/Seat/Seat.css';
import * as SeatsInfo from './components/SeatMap/SeatsInfo/SeatsInfo.css';
import * as SegmentTabs from './components/SegmentTabs/SegmentTabs.css';
import * as SeatTooltip from './components/SeatMap/SeatTooltip/SeatTooltip.css';
import * as RecommendPopup from './components/SeatMap/RecommendPopup/RecommendPopup.css';
import Baggage from './components/Baggage/Baggage.css';
import BaggageCard from './components/Baggage/BaggageCard/BaggageCard.css';
import BaggageList from './components/Baggage/BaggageList/BaggageList.css';
import BaggageTotalPriceBlock from './components/Baggage/BaggageTotalPriceBlock/BaggageTotalPriceBlock.css';
import AdditionalBaggage from './components/Baggage/AdditionalBaggage/AdditionalBaggage.css';
import UpgradeBaggageDialog from './components/Baggage/UpgradeBaggageDialog/UpgradeBaggageDialog.css';
import BaggageCounter from './components/Baggage/BaggageCounter/BaggageCounter.css';
import Modal from './components/Modal/Modal.css';
import Switch from './components/Switch/Switch.css';
import DesktopSummaryFlight from './components/DesktopSummaryFlight/DesktopSummaryFlight.css';
import Contacts from './components/Contacts/Contacts.css';
import CheckoutPassengers from './components/Checkout/Passengers/Passengers.css';
import PassengerForm from './components/PassengerForm/PassengerForm.css';
import PassengerFormHeader from './components/PassengerForm/Header/Header.css';
import PassengerFormGroup from './components/PassengerForm/Group/Group.css';
import PassengerSwitch from './components/Passenger/Switch/Switch.css';
import Input from './components/Input/Input.css';
import OrderCard from './components/OrderCard/OrderCard.css';
import OrderPreview from './components/OrderCard/OrderPreview/OrderPreview.css';
import OrderBooking from './components/OrderCard/OrderBooking/OrderBooking.css';
import OrderChange from './components/OrderCard/OrderChange/OrderChange.css';
import OrderCommonItem from './components/OrderCard/CommonItem/CommonItem.css';
import OrderCardControls from './components/OrderCard/OrderCardControls/OrderCardControls.css';
import PassengersDetails from './components/PassengersDetails/PassengersDetails.css';
import PaymentResult from './components/PaymentResult/PaymentResult.css';
import PromoLoader from './components/PromoLoader/components/PromoLoader.css';
import ResultsError from './components/ResultsError/ResultsError.css';
import FareConditions from './components/FareConditions/FareConditions.css';
import IncludedBaggage from './components/IncludedBaggage/IncludedBaggage.css';
import RetrieveBooking from './components/RetrieveBooking/RetrieveBooking.css';
import Checkin from './components/Checkin/Checkin.css';
import AddPassenger from './components/AddPassenger/AddPassenger.css';
import Segment from './components/Segment/Segment.css';
import StatusMessage from './components/StatusMessage/StatusMessage.css';
import RegisteredPassenger from './components/RegisteredPassenger/RegisteredPassenger.css';
import MobileSegment from './components/MobileSegment/MobileSegment.css';
import ServiceWithSegments from './components/ServiceWithSegments/ServiceWithSegments.css';
import SuggestionModalContent from './components/SuggestionModalContent/SuggestionModalContent.css';
import PassengersToolbar from './components/Checkout/components/Checkout/Form/PassengersToolbar/PassengersToolbar.css';
import RegistrationForm from './components/LoginPage/components/LoginForm/RegistrationForm/RegistrationForm.css';
import PaymentForm from './components/PaymentForm/components/PaymentForm.css';
import PaymentFormRoot from './components/PaymentForm/PaymentForm.css';
import MealService from './components/MealService/MealService.css';
import Meal from './components/Meal/Meal.css';
import Counter from './components/Counter/Counter.css';
const theme = {
    LoginPage: {
        RegistrationForm: {
            label: RegistrationForm.label
        }
    },
    SegmentTabs: {
        SegmentTab: {
            checked: SegmentTabs.checked,
            segment: SegmentTabs.segment,
            segment_active: SegmentTabs.active
        },
        SegmentTabs: {
            wrapper: SegmentTabs.wrapper,
            inner: SegmentTabs.inner,
            title: SegmentTabs.title
        }
    },
    SearchForm: {
        SearchForm: {
            searchForm: SearchForm.searchForm
        },
        Currency: {
            currency: SearchForm.currency,
            arrowIcon: SearchForm.currency__arrowIcon
        },
        StartSearch: {
            startSearch: SearchForm.startSearch,
            startSearch_iconMode: SearchForm.startSearch__IconMode,
            startSearch_multiCity: SearchForm.startSearch__MultiCity
        },
        Value: {
            value: SearchForm.value,
            code: SearchForm.value__code
        },
        MultiCity: {
            caption: SearchForm.multiCity__caption,
            multiCity: SearchForm.multiCity
        },
        Bottom: {
            controls: SearchForm.bottom__controls
        },
        Segments: {
            segments_multiCity: SearchForm.segments__segmentsMultiCity
        },
        Datepicker: {
            dates: SearchForm.datepicker__dates,
            alternative: SearchForm.datepicker__alternative,
            dow: SearchForm.datepicker__dow,
            alternative_dow: SearchForm.datepicker__alternativeDow
        },
        Segment: {
            wrapper: SearchForm.segment__wrapper,
            withMultiCity: SearchForm.segment__withMultiCity,
            cell: SearchForm.segment__cell
        },
        Location: {
            input: SearchForm.location__input
        },
        Passengers: {
            mobileTitle: SearchForm.passengers_mobileTitle
        }
    },
    LocationAutocomplete: {
        Group: {
            group__label: LocationAutocomplete.group__label
        },
        DirectionsDialog: {
            city: LocationAutocomplete.directionsDialog__label
        }
    },
    SearchFormDatepicker: {
        DayStyles: {
            day_selected: SearchFormDatepicker.dayStyles__daySelected,
            day_withPrice: SearchFormDatepicker.dayStyles__dayWithPrice,
            day_today: SearchFormDatepicker.dayStyles__dayToday
        },
        SearchFormDatepickerStyles: {
            footer__clear: SearchFormDatepicker.searchFormDatepickerStyles__footerClear,
            footer__done: SearchFormDatepicker.searchFormDatepickerStyles__footerDone,
            footer__buttons: SearchFormDatepicker.searchFormDatepickerStyles__footerButtons
        }
    },
    Segment: {
        SegmentCommon: {
            wrapper: Segment.segmentCommon__wrapper,
            wrapper_business: Segment.segmentCommon__wrapperBusiness,
            header: Segment.segmentCommon__header
        }
    },
    Passengers: {
        PassengerStyles: {
            increase: Passengers.increase,
            decrease: Passengers.decrease
        }
    },
    Results: {
        Results: {
            results_hasErrors: QuickSearchForm.results_hasErrors,
            header: Results.header,
            header__stepbar: Results.headerStepbar,
            toolbar__backButton: Results.toolbarBackButton
        },
        Calendar: {
            legNumber: Results.calendar__legNumber,
            header: Results.calendar__header,
            title__cities: Results.calendar__titleCities,
            diagram: Results.calendar__diagram
        },
        FlightsList: {
            leg: Results.flightsList__leg
        },
        SelectedFares: {
            price: Results.selectedFares__price
        }
    },
    Stepbar: {
        Step: {
            step: Stepbar.step,
            step_active: Stepbar.step__stepActive,
            step_passed: Stepbar.step__stepPassed,
            step_disabled: Stepbar.step__stepDisabled,
            id: Stepbar.step__id
        },
        Stepbar: {
            cart: Stepbar.stepbar__cart
        }
    },
    QuickSearchForm: {
        QuickSearchForm: {
            wrapper: QuickSearchForm.wrapper,
            outer__summary: QuickSearchForm.outerSummary,
            outer__summary_open: QuickSearchForm.outerSummaryOpen,
            form: QuickSearchForm.form,
            form__wrapper: QuickSearchForm.formWrapper,
            outer: QuickSearchForm.outer
        },
        Summary: {
            passengers: QuickSearchForm.summary__passengers,
            route: QuickSearchForm.summary__route,
            dates: QuickSearchForm.summary__dates
        }
    },
    PriceGraph: {
        MonthsListStyles: {
            currentMonth: PriceGraph.months__currentMonth,
            month__name: PriceGraph.months__monthName
        }
    },
    WeekCalendar: {
        DayStyles: {
            date: WeekCalendar.dayStyles__date,
            date__info: WeekCalendar.dayStyles__dateInfo,
            price: WeekCalendar.dayStyles__price,
            day_selected: WeekCalendar.dayStyles__daySelected,
            day: WeekCalendar.dayStyles__day
        },
        WeekCalendarStyles: {
            dayWrapper: WeekCalendar.weekCalendarStyles__dayWrapper,
            dayWrapper_selected: WeekCalendar.weekCalendarStyles__dayWrapperSelected
        },
        SliderStyles: {
            elementsWrapper: WeekCalendar.sliderStyles__elementsWrapper
        }
    },
    DesktopFlightRoute: {
        SegmentStyles: {
            flightInfo__date: DesktopFlightRoute.segmentStyles__flightInfoDate
        },
        RouteArrowStyles: {
            flightNumber: DesktopFlightRoute.routeArrowStyles__flightInfoDate,
            timeInRoute: DesktopFlightRoute.segmentStyles__timeInRoute
        },
        FlightPriceStyles: {
            button: DesktopFlightRoute.flightPriceStyles__button,
            seats: DesktopFlightRoute.flightPriceStyles__seats,
            clear: DesktopFlightRoute.flightPriceStyles__clear
        },
        DesktopFlightRouteStyles: {
            flight: DesktopFlightRoute.desktopFlightRouteStyles__flight,
            selected: DesktopFlightRoute.desktopFlightRouteStyles__selected
        }
    },
    Amenities: {
        Amenities: {
            amenities__item: Amenities.item
        }
    },
    DesktopFlight: {
        ModalContent: {
            fareGroup__button_active: DesktopFlight.modalContent__fareGroupButtonActive,
            fareGroup__button: DesktopFlight.modalContent__fareGroupButton,
            fareGroup__button_business: DesktopFlight.modalContent__fareGroupButtonBusiness
        },
        Location: {
            airport: DesktopFlight.location__airport,
            terminal_iata: DesktopFlight.location__terminalIata
        },
        DesktopFlightModalHeader: {
            close: DesktopFlight.desktopFlightModalHeader__close,
            close__icon: DesktopFlight.desktopFlightModalHeader__closeIcon
        },
        SelectedFareGroup: {
            button: DesktopFlight.selectedFareGroup__button,
            button__rules: DesktopFlight.selectedFareGroup__buttonRules,
            fareConditions__closeButton: DesktopFlight.selectedFareGroup__fareConditionsCloseButton
        },
        FlightInfoSegment: {
            isMobile: DesktopFlight.flightInfoSegment__isMobile,
            card: DesktopFlight.flightInfoSegment__card,
            flight: DesktopFlight.flightInfoSegment__flight,
            location: DesktopFlight.flightInfoSegment__location
        }
    },
    FareGroup: {
        FareGroup: {
            fareGroup_white: FareGroup.fareGroupWhite,
            option__title: FareGroup.optionTitle,
            option__value: FareGroup.optionValue,
            fareGroup: FareGroup.fareGroup,
            fareGroup_Business: FareGroup.fareGroup__Business,
            keyFeature: FareGroup.fareGroup__keyFeature
        },
        FareGroupGrid: {
            option: FareGroup.fareGroupGrid__option,
            small: FareGroup.fareGroupGrid__small,
            container: FareGroup.fareGroupGrid__container
        },
        RecommendedBadge: {
            badge: FareGroup.recommendedBadge__badge
        }
    },
    FlightCard: {
        FlightCard: {
            aircraft__name_active: FlightCard.aircraftNameActive,
            wrapper: FlightCard.wrapper,
            airline: FlightCard.airline
        }
    },
    Toolbar: {
        Toolbar: {
            toolbar: Toolbar.toolbar,
            button: Toolbar.button,
            price: Toolbar.price,
            backButton: Toolbar.backButton,
            backButton__wrapper: Toolbar.backButtonWrapper
        }
    },
    Checkout: {
        CheckoutStyles: {
            container: Checkout.container,
            gdsTotalPrice: Checkout.gdsTotalPrice,
            form: Checkout.form,
            payment__close: cn(PaymentResult.close)
        },
        PassengersStyles: {
            passengers: CheckoutPassengers.passengers
        },
        PassengersToolbar: {
            label: cn(PassengersToolbar.label, CheckoutPassengers.toolbar__label, Checkout.passengersToolbar__label)
        },
        Consents: {
            consents__text: CheckoutConsents.consents__text
        }
    },
    MobileFlight: {
        FlightStyles: {
            price: MobileFlight.price,
            selectedFare: MobileFlight.selectedFare,
            flight: MobileFlight.flight,
            flight_selected: MobileFlight.flight_selected
        }
    },
    CompareFares: {
        CompareFares: {
            slider: CompareFares.slider,
            compareFares: CompareFares.compareFares,
            headingWrp: CompareFares.headingWrp
        }
    },
    FareConditions: {
        FareConditions: {
            segmentTabsWrapper: FareConditions.segmentTabsWrapper
        }
    },
    Modal: {
        Modal: {
            closeIcon: Modal.closeIcon,
            modal_rounded: cn(Modal.modalRounded, Modal.modal_rounded),
            modal: Modal.modal
        }
    },
    DesktopSummaryFlight: {
        SummaryFlight: {
            flight: DesktopSummaryFlight.flight
        }
    },
    Contacts: {
        ContactsStyles: {
            contacts: Contacts.contacts,
            header: Contacts.header,
            description__header: Contacts.description__header,
            description__text: Contacts.description__text
        }
    },
    PassengerForm: {
        PassengerForm: {
            form: PassengerForm.form
        },
        Header: {
            header: PassengerFormHeader.header,
            filled: PassengerFormHeader.filled,
            number: PassengerFormHeader.number,
            passengerName: PassengerFormHeader.passengerName,
            payload: PassengerFormHeader.payload
        },
        Group: {
            container: cn(PassengerFormGroup.container, PassengerFormGroup.container_icon),
            identity: PassengerFormGroup.identity,
            documents: PassengerFormGroup.documents
        },
        LoyaltyGroup: {
            container_loyalty: PassengerFormGroup.loyalty
        },
        Disabilities: {
            container: cn(PassengerFormGroup.disabilities, PassengerFormGroup.container_icon)
        }
    },
    Passenger: {
        Switch: {
            element: PassengerSwitch.element,
            element_active: PassengerSwitch.element_active,
            element_error: PassengerSwitch.element_error,
            error: cn(PassengerSwitch.error, PassengerFormGroup.switch__error)
        }
    },
    Input: {
        Input: {
            hint: Input.hint,
            input: Input.input,
            input_focused: Input.input_focused,
            underline: Input.underline
        }
    },
    OrderCard: {
        OrderCard: {
            type_account: OrderCard.type_account,
            type_review: OrderCard.type_review,
            container: OrderCard.container,
            root: OrderCard.root,
            preview: OrderCard.preview,
            status: OrderCard.status
        },
        OrderPreview: {
            root: cn(OrderCard.orderPreview),
            overlay: OrderPreview.overlay,
            inner: OrderPreview.inner,
            city: OrderPreview.city,
            main_city: OrderPreview.main_city,
            period: OrderPreview.period
        },
        OrderBooking: {
            type_account: OrderBooking.type_account,
            type_review: OrderBooking.type_review,
            root: OrderBooking.root,
            orderCode: OrderBooking.orderCode,
            download: OrderBooking.download,
            security_code: OrderBooking.security_code
        },
        OrderPassengers: {
            control: OrderCard.link,
            paper: OrderCard.paper
        },
        OrderTickets: {
            link: OrderCard.link
        },
        CommonItem: {
            root: OrderCommonItem.root,
            review: OrderCommonItem.review,
            payload: cn(OrderCard.payload),
            icon: OrderCommonItem.icon
        },
        OrderChange: {
            button: OrderChange.button
        },
        OrderCardControls: {
            root: OrderCardControls.root,
            button: OrderCardControls.button,
            button_checkin: cn(OrderCardControls.button_checkin, OrderCard.button_checkin)
        }
    },
    SeatMap: {
        SeatServiceSlide: {
            single: Controls.single
        },
        MobilePassenger: {
            container: MobilePassenger.container,
            active: MobilePassenger.active
        },
        ComponentStyles: {
            header_mobile: SeatMap.header_mobile,
            header_passengers: SeatMap.header_passengers,
            map: SeatMap.map,
            wrapper_fourServices: SeatMap.wrapper_fourServices,
            dialogWrapper: SeatMap.dialogWrapper,
            seatsInfo: SeatMap.seatsInfo
        },
        SeatMapStyles: {
            seatMap__wrapper: SeatMap.seatMap__wrapper,
            container: SeatMap.seatMap__container,
            seatMap: SeatMap.seatMap,
            row__serviceHeader: SeatMap.row__serviceHeader,
            wings: SeatMap.seatMap__wings,
            row: SeatMap.row
            // row__serviceHeader__wrapper: SeatMap.seatMap__rowServiceHeaderWrapper,
            // row_serviceHeader_from: SeatMap.seatMap__rowServiceHeaderFrom,
            // row_serviceHeader_from_after: SeatMap.row_serviceHeader_from_after,
            // exit__label: SeatMap.seatMap__exitLabel
        },
        AirplaneStyles: {
            airplane: Airplane.airplane,
            airplane__name: Airplane.airplane__airplaneName,
            airplane__info: Airplane.airplane__info,
            details: Airplane.airplane__details,
            airplane__image: Airplane.airplane__image,
            seatsDetails: Airplane.seatsDetails
            // segment: SeatMap.airplane__segment
        },
        AirplaneInfoStyles: {
            sunInfo: AirplaneInfo.airplaneInfo__sunInfo
        },
        Passenger: {
            item: Passenger.item,
            item_active: Passenger.item_active,
            main: Passenger.main,
            select: Passenger.select,
            avatar: Passenger.avatar,
            money: Passenger.money,
            numbers: Passenger.numbers,
            freeSeat__text: Passenger.freeSeat__text,
            clear: Passenger.clear,
            payload: Passenger.payload,
            item_recommend: Passenger.item_recommend,
            passengerName: Passenger.passengerName
            // select_selected: SeatMap.passenger__selectSelected
            // avatar: SeatMap.passenger__avatar,
            // passengerName: SeatMap.passenger__passengerName,
            // icon: SeatMap.passenger__icon,
            // select_selected: SeatMap.passenger__selectSelected,
            // item_confirmed: SeatMap.passenger__itemConfirmed,
            // clear: SeatMap.passenger__seatClear,
            // selectMobile: SeatMap.passenger__selectMobile,
            // selectMobile_selected: SeatMap.passenger__selectMobile_selected
        },
        DoubleSeat: {
            container: DoubleSeat.container,
            description: DoubleSeat.description,
            switch__icon: DoubleSeat.switch__icon,
            switch__label: DoubleSeat.switch__label
        },
        PassengersStyles: {
            recommend: SeatMapPassengers.recommend,
            recommend__icon: SeatMapPassengers.recommend__icon,
            recommend__wrapper: SeatMapPassengers.recommend__wrapper,
            passengers__button: SeatMapPassengers.passengers__button,
            passengers__button_clear: SeatMapPassengers.passengers__button_clear,
            passengers_recommend: Passenger.passengers_recommend,
            recommend__label: SeatMapPassengers.recommend__label
        },
        Controls: {
            controls: Controls.controls,
            button: Controls.controls__button,
            back: Controls.back
        },
        SeatMapDisclaimerStyles: {
            disclaimer: Disclaimer.disclaimer
        },
        SeatsInfoStyles: {
            seat: SeatsInfo.seat,
            freeSeat__container: SeatsInfo.freeSeat__container,
            description: SeatsInfo.description,
            price: SeatsInfo.price,
            price__wrapper: SeatsInfo.price__wrapper,
            seat__info: SeatsInfo.seat__info,
            header: SeatsInfo.header,
            title: SeatsInfo.title,
            note: SeatsInfo.note,
            info: SeatsInfo.info
            // classInfo__payload: SeatMap.seatsInfo__classInfoPayload,
            // title: SeatMap.seatsInfo__title,
            // seat__info: SeatMap.seatsInfo__seatInfo,
            // feature: SeatMap.seatMap__feature,
            // seat_preferred: SeatMap.seatsInfo__seatPreferred,
            // seat__icon: SeatMap.seatsInfo__seatIcon
        },
        SeatStyles: {
            seat: Seat.seat,
            number: Seat.number,
            seat_occupied: Seat.seat_occupied
            // seat_free: SeatMap.seat_free,
            // seat_business: SeatMap.seat__seatBusiness,
            // seat_preferred: SeatMap.seat__seatPreferred,
            // seat_unavailable: SeatMap.seat__seatUnavailable,
            // seat_unexistent: SeatMap.seat__seatUnexistent,
            // seat_recommend: SeatMap.seat__seatRecommend,
            // seat_recommendCurrent: SeatMap.seat__seatRecommendCurrent
        },
        SeatsRecommendPopup: {
            recomended: RecommendPopup.recomended
            // main: SeatMap.seatRecommendPopup__main,
            // main__icon: SeatMap.seatRecommendPopup__mainIcon,
            // price__wrapper: SeatMap.seatRecommendPopup__priceWrapper,
            // money: SeatMap.seatRecommendPopup__money
        },
        SeatTooltipStyles: {
            tooltip: SeatTooltip.tooltip,
            number: SeatTooltip.number,
            container: SeatTooltip.container,
            details: SeatTooltip.details,
            details__seatName: SeatTooltip.details__seatName,
            info: SeatTooltip.info,
            tooltip_withInfo: SeatTooltip.tooltip_withInfo
        }
    },
    Checkin: {
        Passengers: {
            toolbar__button: Checkin.passengers__toolbarButton,
            checkinCancelModal__text: Checkin.passengers__checkinCancelModalText,
            title: Checkin.passengers__title
        },
        Hint: {
            title: Checkin.hint__title
        }
    },
    MobileSegment: {
        MobileSegment: {
            wrapper: MobileSegment.wrapper,
            wrapper_business: MobileSegment.wrapper_business,
            fareGroup: MobileSegment.fareGroup
        }
    },
    AddPassenger: {
        AddPassenger: {
            passengerIcon: AddPassenger.passengerIcon,
            form: AddPassenger.form,
            addButton: AddPassenger.addButton
        }
    },
    Baggage: {
        Baggage: {
            icon: Baggage.icon,
            size: Baggage.size,
            name: Baggage.name
        },
        BaggageIcon: {
            wrapper: Baggage.baggageIcon_wrapper
        }
    },
    BaggageCard: {
        BaggageCard: {
            price: BaggageCard.price,
            icon: BaggageCard.icon,
            footer: BaggageCard.footer
        }
    },
    BaggageTotalPriceBlock: {
        BaggageTotalPriceBlock: {
            price: BaggageTotalPriceBlock.price
        }
    },
    BaggageList: {
        BaggageList: {
            add: BaggageList.add
        }
    },
    AdditionalBaggage: {
        AdditionalBaggage: {
            promo_message: AdditionalBaggage.promo_message,
            header: AdditionalBaggage.header
        }
    },
    IncludedBaggage: {
        IncludedBaggage: {
            header: IncludedBaggage.header
        }
    },
    UpgradeBaggageDialog: {
        BaggageFooter: {
            root: UpgradeBaggageDialog.baggageFooter_root,
            clear: UpgradeBaggageDialog.baggageFooter_clear
        },
        BaggagePassenger: {
            number: UpgradeBaggageDialog.baggagePassenger_number,
            checkbox_root: UpgradeBaggageDialog.baggagePassenger_checkbox_root,
            checkbox_rootChecked: UpgradeBaggageDialog.baggagePassenger_checkbox_rootChecked,
            counter_wrapper: UpgradeBaggageDialog.baggagePassenger_counter_wrapper
        },
        BaggageDialogHeader: {
            baggage_wrapper: UpgradeBaggageDialog.baggageDialogHeader_baggage_wrapper,
            category_title: UpgradeBaggageDialog.baggageDialogHeader_category_title
        },
        HeaderEquipmentItem: {
            wrapper_pointer: UpgradeBaggageDialog.equipmentItem__pointer,
            active: UpgradeBaggageDialog.equipmentItem__pointer_active
        },
        BaggageSegment: {
            root: UpgradeBaggageDialog.baggageSegment__root
        },
        MobileBaggageSelector: {
            description: UpgradeBaggageDialog.mobileBaggageSelector__description
        },
        UpgradeBaggageDialog: {
            close: UpgradeBaggageDialog.close
        }
    },
    BaggageCounter: {
        BaggageCounter: {
            plus: BaggageCounter.plus,
            minus: BaggageCounter.minus,
            disabled: BaggageCounter.disabled
        }
    },
    Switch: {
        SwitchV2: {
            primary: Switch.primary,
            active: Switch.active
        }
    },
    PassengersDetails: {
        PassengersDetails: {
            close: PassengersDetails.close,
            wrapper: PassengersDetails.wrapper
        }
    },
    PaymentResult: {
        PaymentResult: {
            header: PaymentResult.header
        }
    },
    PaymentForm: {
        PaymentForm: {
            wrapper: PaymentForm.wrapper,
            cards_header: PaymentForm.cards_header,
            content: PaymentFormRoot.content,
            vakifbank: PaymentForm.vakifbank,
            paylate_asCard: PaymentForm.paylate_asCard
        },
        Gateway: {
            header__arrow: PaymentForm.gateway__headerArrow
        }
    },
    PromoLoader: {
        PromoLoader: {
            promo__image: PromoLoader.image,
            promo__content: PromoLoader.content
        }
    },
    ResultsError: {
        ResultsError: {
            header: ResultsError.header
        }
    },
    RetrieveBooking: {
        RetrieveBooking: {
            form__row: RetrieveBooking.formRow,
            title: RetrieveBooking.title
        }
    },
    StatusMessage: {
        StatusMessage: {
            statusMessage: StatusMessage.statusMessage,
            statusMessage_success: StatusMessage.statusMessage_success,
            statusMessage__title: StatusMessage.statusMessage__title
        }
    },
    RegisteredPassenger: {
        RegisteredPassenger: {
            downloadButton: RegisteredPassenger.downloadButton,
            downloadIcon: RegisteredPassenger.downloadIcon,
            header: RegisteredPassenger.header,
            cancelModal: RegisteredPassenger.cancelModal
        },
        CancelModal: {
            cancelButton: RegisteredPassenger.cancelModal__cancelButton,
            text: RegisteredPassenger.cancelModal__text
        }
    },
    ServiceWithSegments: {
        ServiceWithSegments: {
            title: ServiceWithSegments.title
        }
    },
    SuggestionModalContent: {
        SuggestionModalContent: {
            modal__text: SuggestionModalContent.modal__text
        }
    },
    MealService: {
        List: {
            item: MealService.list__item,
            item_selected: MealService.list__itemSelected
        }
    },
    Meal: {
        Meal: {
            price: Meal.price,
            meal: Meal.meal
        },
        Details: {
            trigger: Meal.details__trigger,
            name: Meal.details__name,
            price: Meal.details__price,
            description__row: Meal.details__descriptionRow,
            passenger: Meal.details__passenger,
            total: Meal.details__total,
            totalText: Meal.details__totalText,
            clear: Meal.details__clear,
            footer: Meal.details__footer,
            image: Meal.details__image,
            selector: Meal.details__selector
        }
    },
    Counter: {
        Counter: {
            button: Counter.button,
            button_disabled: cn(Counter.button_disabled, BaggageCounter.disabled)
        }
    }
};
export default theme;
